/**
 * All unprotected parameter
 */
export enum UnprotectedParameterEnum {
  TICKET_SEARCH_MAX_RESULTS = 'TICKET_SEARCH_MAX_RESULTS',
  CLOUD_EXPORT_ALLOW_ASYNC = 'CLOUD_EXPORT_ALLOW_ASYNC',
  CLOUD_EXPORT_ALLOW_SYNC = 'CLOUD_EXPORT_ALLOW_SYNC',
  CASE_ACTION_COMMENT_SETTING = 'CASE_ACTION_COMMENT_SETTING',
  KB_SYNCHRONIZATION_FREQUENCY = 'KB_SYNCHRONIZATION_FREQUENCY',
  USE_AUDIT_FEATURE = 'USE_AUDIT_FEATURE',
  USE_MCR_FEATURE = 'USE_MCR_FEATURE',
  TRANSFERT_MODE = 'TRANSFERT_MODE',
  TRANSFER_INTERSPACE = 'TRANSFER_INTERSPACE',
  CUSTOMER_EXTERNAL_REFERENCE_URL = 'CUSTOMER_EXTERNAL_REFERENCE_URL',
}

/**
 * Instance Parameter interface
 */
export interface InstanceParameterDTOV1 {
  code: UnprotectedParameterEnum | string
  name: string
  description: string
  value: string
}

export enum TransfertModeEnum {
  ALL = 'ALL',
  CUSTOM = 'CUSTOM',
}

export enum CaseActionCommentModeEnum {
  MANDATORY = 'MANDATORY',
  OPTIONAL = 'OPTIONAL',
  NONE = 'NONE',
}
